var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.controlComponent,_vm._g(_vm._b({ref:"control",tag:"component",staticClass:"ui-time-picker",class:{ 'is-block': _vm.block },attrs:{"value":_vm.value,"popper-class":_vm.resolvedPopperClass},on:{"input":function($event){return _vm.$emit('input', $event)}}},'component',_vm.$attrs,false),_vm.forwardedListeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }